import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { API_BASE } from "../api";
import { useAuth } from "../context/AuthContext";
//import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import BaseLayout from "./BaseLayout";

const LoginPage = () => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState({ type: "", content: "" });
  const navigate = useNavigate();
  const { setAuthData } = useAuth();

  useEffect(() => {
    localStorage.removeItem("token");
    setAuthData({ isAuthenticated: false, token: null });
    //console.log("Authentication state cleared");
  }, [setAuthData]);
 
    /*const googleSubmit = async (googleResponse) => {
    setMessage({ type: "", content: ""});
    //console.log("Response:")
    //console.log(googleResponse);

    try {
    
            const googleCredential = await axios.post(`${API_BASE}/google-login`,
                    {id_token : googleResponse.credential}
                  );
        const { access_token, user } = googleCredential.data;

        setMessage({
      type: "success",
      content:  "Login successful! Redirecting...",
        });

        setTimeout(() => {
      localStorage.setItem("token", access_token);
      localStorage.setItem("user", JSON.stringify(user));
      setAuthData({ isAuthenticated: true, token: access_token, user: user });
      navigate("/home");
        }, 1500);
    }
      
    catch (error) {
        if (error.response) {
      setMessage({ type: "error", content: error.response.data.error });
        } else {
      setMessage({
          type: "error",
          content: "An error occurred. Please try again.",
      });
        }
    }
      }

      const googleError = async (googleError) => {
          setMessage({ type: "error", content: googleError});
      }*/

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage({ type: "", content: "" });

    if (password.length < 8) {
      setMessage({
        type: "error",
        content: "Password must be at least 8 characters long.",
      });
      return;
    }

    try {
      const response = await axios.post(`${API_BASE}/login`, {
        identifier,
        password,
      });
      const { access_token, user } = response.data;

      setMessage({
        type: "success",
        content: "Login successful! Redirecting...",
      });

      setTimeout(() => {
        localStorage.setItem("token", access_token);

        if (user.profile_picture && checkProfilePictureSize(user.profile_picture)) {
          //console.log("Profile picture too large. Setting to default.");
          const modifiedUser = { ...user, profile_picture: "large" };
          localStorage.setItem("user", JSON.stringify(modifiedUser));
          setAuthData({ isAuthenticated: true, token: access_token, user: modifiedUser });
        } else {
          //console.log("Profile picture is within size limit.");
          localStorage.setItem("user", JSON.stringify(user));
          setAuthData({ isAuthenticated: true, token: access_token, user: user });
        }

        navigate('/home');
      }, 1500);
    } catch (error) {
      if (error.response) {
        setMessage({ type: "error", content: error.response.data.error });
      } else {
        setMessage({
          type: "error",
          content: "An error occurred. Please try again.",
        });
      }
    }
  };

  function checkProfilePictureSize(base64String) {
    const base64WithoutHeader = base64String.split(',')[1] || base64String;
    const byteLength = parseInt((base64WithoutHeader.length * 3) / 4 - (base64WithoutHeader.match(/==?$/g) || []).length);
    const sizeInMB = byteLength / 1024 / 1024;
    //console.log("Profile picture size: " + sizeInMB.toFixed(3) + " MB");
    return sizeInMB > 3;
}

  return (
    <BaseLayout>
      <div className="auth-wrapper">
        <img
          src="/loginlogo.png"
          className="auth-logo"
          alt="FlamePicks"
        />
        <div className="auth-card">
          {message.content && (
            <div
              className={`alert ${message.type === "error" ? "alert-danger" : "alert-success"}`}
              role="alert"
            >
              {message.content}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="identifier">Email or Username</label>
              <input
                type="text"
                className="form-control"
                id="identifier"
                name="identifier"
                placeholder="Enter email or username"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                autoComplete="username"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button type="submit" className="auth-submit-btn">
              Sign In
            </button>
          </form>
          <div className="auth-footer-link">
            <Link to="/forgot-password" style={{ display: "block", marginBottom: "0.6rem" }}>Forgot your password?</Link>
            Don't have an account? <Link to="/sign-up">Sign up free</Link>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default LoginPage;
